import { render, staticRenderFns } from "./EditCrmConfig.vue?vue&type=template&id=23d1e3b8&"
import script from "./EditCrmConfig.vue?vue&type=script&lang=js&"
export * from "./EditCrmConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports